import { ServiceApplication_Key } from "../../../../config/helpers";
import { IFilterMessage } from "../../../../models/interfaces/IFilterMessage";
import { IMessage, IMessageReturn, IMessagesReturn } from "../../../../models/interfaces/IMessage";
import { IReturn_Parent } from "../../../../models/interfaces/IReturn_Parent";

import { apiSlice } from "../../api";

export interface messageApiQueryBody {
    Application_Key: string;
    // eslint-disable-next-line
    Values: any;
}

export const messageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    deletemessage: builder.mutation<IReturn_Parent,number>({
      query: (idmessage) => {
      const body: messageApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {
          IdMessage: idmessage,
        },
      };
      return {
        url: "/message/Message_Delete",
        method: "POST",
        body: body,
      };
    },
  }),
    createmessage: builder.mutation<IMessageReturn, IMessage>({
        query: (data) => {
        const body: messageApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/message/Message_Create",
          method: "POST",
          body: body,
        };
      },
    }),
    updatedemandemessage: builder.mutation<IMessageReturn, IMessage>({
      query: (data) => {
      const body: messageApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: data,
      };
      return {
        url: "/message/Message_Update_Demande",
        method: "POST",
        body: body,
      };
    },
  }),

    fetchmessagesEAN: builder.query<IMessagesReturn, IFilterMessage|undefined>({
      query: (obj) => {
        const body: messageApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };
        return {
          url: "/message/MessageEan_Search",
          method: "POST",
          body: body,
        };
      },
      }),
      fetchmessagesMarque: builder.query<IMessagesReturn, IFilterMessage|undefined>({
        query: (obj) => {
          const body: messageApiQueryBody = {
            Application_Key: ServiceApplication_Key,
            Values: obj,
          };
          return {
            url: "/message/MessageMarque_Search",
            method: "POST",
            body: body,
          };
        },
        }),
  
  

  fetchmessage: builder.query<IMessageReturn, number>({
    query: (id: number) => {
      const body: messageApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {
          IdMessage: id,
        },
      };
      return {
        url: "/message/Message_Get",
        method: "POST",
        body: body,
      };
    },
    }),
}),
});

export const {
  useCreatemessageMutation,
  useDeletemessageMutation,
  useUpdatedemandemessageMutation,
  useFetchmessagesEANQuery,
  useFetchmessagesMarqueQuery,
  useFetchmessageQuery,
  useLazyFetchmessageQuery,
 } = messageApi;
